import { Action } from "..";
import { EMAIL_CHANGE, HASH_CHANGE, TYPE_CHANGE } from "../actions/admin";

export interface AdminState {
  email: string | null;
  hash: string | null;
  type: string | null;
}

const initialState: AdminState = {
  email: null,
  hash: null,
  type: null,
};

const adminReducer = (
  state: AdminState = initialState,
  action: Action
): AdminState => {
  switch (action.type) {
    case EMAIL_CHANGE:
      return { ...state, email: action.payload };
    case HASH_CHANGE:
      return { ...state, hash: action.payload };
    case TYPE_CHANGE:
      return { ...state, type: action.payload };
    default:
      return state;
  }
};

export default adminReducer;
